import {
  Grid,
  Typography,
  CardContent,
  CardHeader,
  useTheme,
  Card,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import {
  JobBody,
  JobTitle,
  StyledCard,
  StyledCardHeader,
} from "../../../styles/OurJobsStyles";
import {
  AccompagnementQHSE,
  AccompagnementQHSE2,
} from "../../../data/TabsContent";
import { motion } from "framer-motion";

const QHSE = () => {
  return (
    <Box component={motion.div} /* initial={{ x: 500 }} animate={{ x: 0 }} */>
      <JobTitle>QHSE</JobTitle>
      <Box mb={2}>
        <JobBody>
          <b> AFRIQUALEOS </b> accompagne ses clients jusqu'à la certification,
          simple ou combinée, selon les normes suivantes :
        </JobBody>
      </Box>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        {/* {AccompagnementQHSE.map((item, index) => {
          return (
            <Grid key={index} item xs={12} sm={6} md={3}>
              <CardItem item={item} />
            </Grid>
          );
        })} */}
        <Grid item xs={0} sm={4} />
        <Grid item xs={12} sm={4}>
          <CardItem item="ISO 9001 v2015" />
        </Grid>
        <Grid item xs={0} sm={4} />

        <Grid item xs={12} sm={4}>
          <CardItem item="ISO 14001 v2015" />
        </Grid>
        <Grid item xs={0} sm={4} justifyContent="center">
          <StyledCard
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: 2,
              borderRadius: "50%",
              width: "250px",
              margin: "0 auto",
            }}
          >
            <img
              style={{
                width: "200px",
              }}
              src="./static/images/logo.png"
              alt="logo"
            />
          </StyledCard>
        </Grid>
        <Grid item xs={12} sm={4}>
          <CardItem item="ISO 45001 v2015" />
        </Grid>

        <Grid item xs={0} sm={3} />
        <Grid item xs={12} sm={3}>
          <CardItem item="ISO 50001 v2018" />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CardItem item="ISO 27001 v2018" />
        </Grid>
        <Grid item xs={0} sm={3} />
      </Grid>
      <Box mb={2} mt={4}>
        <JobBody>
          <b> AFRIQUALEOS </b> accompagne également ses clients à la réalisation
          des études suivantes :
        </JobBody>
      </Box>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        {/* {AccompagnementQHSE2.map((item, index) => {
          return (
            <Grid key={index} item xs={12} sm={12}>
              <CardItem item={item} />
            </Grid>
          );
        })} */}
        <Grid item xs={12} sm={4}>
          <CardItem item="Analyse environnementale" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CardItem item="Étude d'impact sur l'environnement" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CardItem item="Étude d'impact sur l'environnement" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CardItem item="Étude des installations incendie" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CardItem item="Analyse des risques SST" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default QHSE;

const CardItem = ({ item, open, setOpen }) => {
  return (
    <StyledCard>
      <StyledCardHeader title={item} />
    </StyledCard>
  );
};
